module.exports = __webpack_public_path__ + "static/media/zumba.62379aad.webp";